import * as React from "react";
import { Button, CLOSE_SVG } from 'bpm-web-generic';
import { ERROR_ICON_SVG, WARNING_ICON_SVG, CHECKMARK_SVG } from "src/assets";


export interface PopupProps {
}

export interface PopupStates {
    show: boolean
    title: string;
    text: string;
    okButtonText: string;
    cancelButtonText: string
    type: PopupType,

    loading: boolean,

    onOK: () => void | Promise<any>
    onCancel?: (type: 'button' | 'close') => void
}

export type PopupType = 'warning' | 'info' | 'error' | 'none'
export type PopUpAction = 'ok' | 'cancel' | 'close'
export default class Popup extends React.Component<PopupProps, PopupStates> {

    static expiredMembership() {
        return Popup.show('warning', 'Your Membership Is Not Active', 'You are currently accessing the site with a limited preview. Please purchase a membership to download music.', true, 'Buy Membership')
    }

    static reAuthorizePaypal(okAction: () => Promise<void>) {
        return Popup.show('info', 'Take 50% Off Your Next Month',
            'To redeem this offer, please reauthorize your PayPal payment method. 50% off your subscription amount will be applied to your account next month.', false, 'Continue', undefined, okAction)
    }

    static deleteFromCrate() {
        return Popup.show('info', 'Delete from Crate', 'Do you really want to remove this track from your crate?')
    }

    static downloadLimitExceeded() {
        return Popup.show('error', 'Download Limit', 'You exceeded your download limit on this track.', false)
    }

    static cancelSubscription() {
        return Popup.show('warning', 'Wait! Before you go…', 'Would you like to switch to a Standard Membership for $10 less per month?', true, 'Downgrade Now', 'Cancel Subscription')
    }

    static cancelSubscriptionStandard() {
        return Popup.show('warning', 'Cancel Subscription', 'Do you realy want to cancel your susbcription?')
    }

    static subscribe() {
        return Popup.show('warning', 'Get Access', 'Subscribe to a membership.', true, 'Subscribe')
    }

    static subscriptionSuccess() {
        return Popup.show('info', 'Subscribed', 'You are successfully susbcribed now.', false)
    }

    static subscriptionErrror() {
        return Popup.show('error', 'Error while subscribing', 'You are not successfully susbcribed now.', false)
    }

    static subscriptionReauthorized() {
        return Popup.show('info', 'Success', 'Your PayPal payment method has been successfully reauthorized. 50% off your subscription amount will be applied to your account next billing renewal.', false)
    }

    static upgrade() {
        return Popup.show('warning', 'Upgrade', 'You need a premium membership in order to access to this content.')
    }

    static notVerified(pendingSubmisson: boolean, declined: boolean) {
        if (pendingSubmisson) {
            if (declined) {
                return Popup.show('warning', 'Membership Has Been Denied', 'Please check your email for more information about your membership request', true, 'Resubmit')
            }
            return Popup.show('warning', 'Membership Required', 'Get full access. Request a membership now.')
        } else {
            return Popup.show('none', 'Your Membership Is Being Reviewed', 'Please check your email for more information about <br/>your membership request.', false)
        }
    }

    static loginMembershipDeniedOrNotSubmitted() {
        return Popup.show('warning', 'Membership Required', 'Your membership is not yet active. Please complete a membership request to get started.')
    }

    static loginMembershipPending() {
        return Popup.show('none', 'Your Membership Is Being Reviewed', 'Your membership is not yet active. Please check your email for more information about your membership request.', false)
    }

    static loginMembershipApproved() {
        return Popup.show('info', '', 'Congratulations, you’ve been approved for a membership! To complete your signup, visit ‘My Account’ to complete payment on your account.', true, 'Subscribe')
    }

    static downloadMore() {
        return Popup.show('warning', 'Download More', 'Start downloading music to begin generating this<br />personalized playlist.', false)
    }

    private static _instance: Popup;

    constructor(props: any) {
        super(props)
        this.state = this.defaultState()
        Popup._instance = this;
    }

    private defaultState() {
        return {
            show: false,
            text: '',
            title: '',
            loading: false,
            okButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'info' as PopupType,
            onCancel: () => {

            },
            onOK: () => {

            }
        };
    }

    static show(type: PopupType, title: string, text: string, showCancel: boolean = true, okButtonText = 'OK', cancelButtonText = 'Cancel', okAction?: () => Promise<void>) {
        return new Promise<PopUpAction>((resolve) => {
            this._instance && this._instance.setState({
                show: true, title, text, okButtonText, cancelButtonText, type, onOK: () => {
                    if (okAction) {
                        return okAction()
                    }
                    resolve('ok')
                }, onCancel: showCancel ? (type) => {
                    resolve(type == 'close' ? 'close' : 'cancel')
                } : undefined
            })
        }) as PromiseLike<PopUpAction>
    }

    componentDidMount() {
    }

    onCancel() {
        if (this.state.loading) {
            return
        }
        this.state.onCancel && this.state.onCancel('button')
        this.setState(this.defaultState())
    }

    onClose() {
        if (this.state.loading) {
            return
        }
        this.state.onCancel && this.state.onCancel('close')
        this.setState(this.defaultState())
    }

    onOK() {
        if (this.state.loading) {
            return
        }
        const result = this.state.onOK()

        if (result && 'then' in result && 'catch' in result) {
            this.setState({ loading: true })
            result.catch(() => { }).then(() => {
                this.setState(this.defaultState())
            })
        } else {
            this.setState(this.defaultState())
        }
    }

    public render() {
        return (
            <div>
                <div className={'popup ' + (this.state.show ? 'show' : '')}>
                    <div className='popup_inner'>
                        <div>
                            <div onClick={this.onClose.bind(this)} className="close">
                                <img style={{ float: 'right' }} src={CLOSE_SVG} width={12} />
                            </div>
                        </div>
                        {this.state.type != 'none' && <div className='img'>
                            <img src={this.state.type == 'error' ? ERROR_ICON_SVG : this.state.type == 'warning' ? WARNING_ICON_SVG : CHECKMARK_SVG} width={40} />
                        </div>}
                        <div className="text-container" style={this.state.type != 'none' ? {} : { marginTop: 20 }}>
                            <h2 className="title" dangerouslySetInnerHTML={{ __html: this.state.title }}></h2>
                            <p className="text" dangerouslySetInnerHTML={{ __html: this.state.text }}></p>
                            <div className="button-div">
                                <Button loading={this.state.loading} className="btn-layout delete" text={this.state.okButtonText} color="blue" onClick={this.onOK.bind(this)} style={this.state.onCancel ? {} : { marginRight: 0 }} />
                                {this.state.onCancel && <Button className="reset btn-layout" text={this.state.cancelButtonText} color="blue" onClick={this.onCancel.bind(this)} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/views/Popup.tsx